import { render, staticRenderFns } from "./devDetail.vue?vue&type=template&id=2f20eab8&scoped=true&"
import script from "./devDetail.vue?vue&type=script&lang=js&"
export * from "./devDetail.vue?vue&type=script&lang=js&"
import style0 from "./devDetail.vue?vue&type=style&index=0&id=2f20eab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f20eab8",
  null
  
)

export default component.exports